var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDecoration2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-50 0 200 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.704 47H19.93L0 23.255 19.93 0h20.774l-19.93 23.115L40.705 47z",
    fill: "#08275C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.817 47H57.042l-19.93-23.745L57.043 0h20.775l-19.93 23.115L77.817 47z",
    fill: "#08275C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115 47H94.225l-20-23.745L94.225 0H115L95.07 23.115 115 47z",
    fill: "#08275C"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSItNTAgMCAyMDAgNDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00MC43MDQyIDQ3TDE5LjkyOTYgNDdMLTEuMDM3OTNlLTA2IDIzLjI1NDhMMTkuOTI5NiAtOC43MTE0OWUtMDdMNDAuNzA0MiAtMS43NzkyNGUtMDZMMjAuNzc0NiAyMy4xMTQ4TDQwLjcwNDIgNDdaIiBmaWxsPSIjMDgyNzVDIi8+CjxwYXRoIGQ9Ik03Ny44MTY5IDQ3TDU3LjA0MjIgNDdMMzcuMTEyNyAyMy4yNTQ4TDU3LjA0MjIgLTguNzExNDllLTA3TDc3LjgxNjkgLTEuNzc5MjRlLTA2TDU3Ljg4NzMgMjMuMTE0OEw3Ny44MTY5IDQ3WiIgZmlsbD0iIzA4Mjc1QyIvPgo8cGF0aCBkPSJNMTE1IDQ3TDk0LjIyNTMgNDdMNzQuMjI1MyAyMy4yNTQ4TDk0LjIyNTMgLTguNzQyMjhlLTA3TDExNSAtMS43ODIzMmUtMDZMOTUuMDcwNCAyMy4xMTQ4TDExNSA0N1oiIGZpbGw9IiMwODI3NUMiLz4KPC9zdmc+Cg==";
export { SvgDecoration2 as ReactComponent };